import {computed, makeObservable} from 'mobx';

import type {ID, Nullable} from '../../../utils/utility-types';
import type {CourseModel} from '../Course/Course.model';
import type {DateTimeModel} from '../Date/DateTime.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'ConferenceModel';

export class ConferenceModel extends BaseModel {
  channelId: Nullable<ID>;
  course: Nullable<CourseModel>;
  description: string;
  endDate: DateTimeModel;
  isChatConference: boolean;
  isCreatedByClient: boolean;
  isInCourse: boolean;
  isJoinAvailable: boolean;
  isStarted: boolean;
  startDate: DateTimeModel;
  status: ConferenceModel.Status;
  title: string;
  type: ConferenceModel.Type;

  constructor(props: ConferenceModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<ConferenceModel, ConferenceModel.Props>(
        props,
        {durationTime: computed},
      ),
    );
  }

  get durationTime() {
    const start = this.startDate.format('LT');
    const end = this.endDate.format('LT');

    return `${start} - ${end}`;
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace ConferenceModel {
  export type Props = BaseModel.ModelToProps<ConferenceModel, 'durationTime'>;

  export type Status =
    | 'cancelled'
    | 'ongoing'
    | 'past'
    | 'rescheduled'
    | 'suspended'
    | 'upcoming'
    | 'verbal_cancel';

  export type Type = 'audio' | 'chat' | 'phone' | 'video' | null;
}
